import { render } from "./OnboardingSidebar.vue?vue&type=template&id=01d74712&scoped=true"
import script from "./OnboardingSidebar.vue?vue&type=script&lang=js"
export * from "./OnboardingSidebar.vue?vue&type=script&lang=js"

import "./OnboardingSidebar.vue?vue&type=style&index=0&id=01d74712&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d74712"]])

export default __exports__